module.exports = __webpack_public_path__ + "static/media/home-bg-2023.8e8b5c2f.webp";